import { useMemo } from 'react';
import classNames from 'classnames';

interface Tab<T> {
  title: string;
  value: T;
}

interface TabsProps<T> {
  selected: T;
  items: Tab<T>[];
  onChange: (value: T) => void;
}

type TabWithId<T> = Tab<T> & { id: number };

function Tabs<T>({ items, selected, onChange }: TabsProps<T>) {
  const tabs = useMemo<TabWithId<T>[]>(
    () => items.map((tab, id) => ({ ...tab, id: id + 1 })),
    [items],
  );

  return (
    <div className='Tabs'>
      {tabs.map(tab => (
        <button
          key={tab.id}
          type='button'
          className={classNames('Tabs__item', {
            'Tabs__item--selected': tab.value === selected,
          })}
          onClick={() => onChange(tab.value)}
        >
          {tab.title}
        </button>
      ))}
    </div>
  );
}

export default Tabs;
